/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

import { CardColorProps } from '../BaseIcon'

export const CashPay: FunctionComponent<CardColorProps> = ({ blackAndWhite = false }) => (
  <React.Fragment>
    {!blackAndWhite && (
      <React.Fragment>
        <rect width='40' height='24' fill='#00D64F' rx='2' />
        <path
          fill='#F0F0F0'
          fillRule='evenodd'
          d='M38 1H2a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1ZM2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h36a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Z'
          clipRule='evenodd'
        />
        <path
          fill='#fff'
          fillRule='evenodd'
          d='M20.36 9.13c.86 0 1.68.35 2.21.82.14.12.34.12.47 0l.63-.65a.33.33 0 0 0-.01-.49 5.04 5.04 0 0 0-1.7-.96l.2-.95a.33.33 0 0 0-.34-.4H20.6a.33.33 0 0 0-.32.26l-.18.85c-1.64.08-3.03.9-3.03 2.57 0 1.45 1.15 2.08 2.36 2.5 1.15.44 1.75.6 1.75 1.2 0 .62-.6.99-1.5.99-.8 0-1.66-.27-2.32-.92a.33.33 0 0 0-.47 0l-.68.67a.34.34 0 0 0 0 .48c.53.52 1.21.9 1.98 1.1l-.19.89a.33.33 0 0 0 .33.4l1.23.01a.33.33 0 0 0 .33-.27l.18-.84c1.96-.12 3.16-1.19 3.16-2.75 0-1.43-1.2-2.04-2.65-2.53-.83-.3-1.55-.51-1.55-1.13 0-.6.67-.85 1.34-.85Z'
          clipRule='evenodd'
        />
      </React.Fragment>
    )}
    {blackAndWhite && (
      <React.Fragment>
        <path
          fill='#F0F0F0'
          fillRule='evenodd'
          d='M38 1H2a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1ZM2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h36a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Z'
          clipRule='evenodd'
        />
        <path
          fill='#797979'
          fillRule='evenodd'
          d='M20.36 9.13c.86 0 1.68.35 2.21.82.14.12.34.12.47 0l.63-.65a.33.33 0 0 0-.01-.49 5.04 5.04 0 0 0-1.7-.96l.2-.95a.33.33 0 0 0-.34-.4H20.6a.33.33 0 0 0-.32.26l-.18.85c-1.64.08-3.03.9-3.03 2.57 0 1.45 1.15 2.08 2.36 2.5 1.15.44 1.75.6 1.75 1.2 0 .62-.6.99-1.5.99-.8 0-1.66-.27-2.32-.92a.33.33 0 0 0-.47 0l-.68.67a.34.34 0 0 0 0 .48c.53.52 1.21.9 1.98 1.1l-.19.89a.33.33 0 0 0 .33.4l1.23.01a.33.33 0 0 0 .33-.27l.18-.84c1.96-.12 3.16-1.19 3.16-2.75 0-1.43-1.2-2.04-2.65-2.53-.83-.3-1.55-.51-1.55-1.13 0-.6.67-.85 1.34-.85Z'
          clipRule='evenodd'
        />
      </React.Fragment>
    )}
  </React.Fragment>
)
